import { ShowIf } from '../../../../components/ShowIf';
import { CertificateOfOccupancy } from './components/CertificateOfOccupancy';
import { ProofOfOccupancyFile } from '../../../../components/FileOrFormQuestions/questions/ProofOfOccupancy';
import { CertificateOfOccupancyType } from '@apply/constants';
import { usePropertyCertificateOfOccupancy } from '../../../../../queries/PropertyFields';

interface ProofOfOccupancyProps {
    propertyGuid: string;
    isReview?: boolean;
}

export const ProofOfOccupancy: React.FC<ProofOfOccupancyProps> = ({ propertyGuid, isReview = false }) => {
    const [certificateOfOccupancy] = usePropertyCertificateOfOccupancy(propertyGuid);

    const showProofOfOccupancyFile =
        certificateOfOccupancy !== undefined &&
        [CertificateOfOccupancyType.Yes, CertificateOfOccupancyType.TCO, CertificateOfOccupancyType.LocalEquivalent].includes(
            certificateOfOccupancy
        );

    return (
        <>
            <CertificateOfOccupancy
                propertyGuid={propertyGuid}
                required={true}
                isReview={isReview}
            />
            <ShowIf showIf={showProofOfOccupancyFile}>
                <ProofOfOccupancyFile
                    propertyGuid={propertyGuid}
                    required={true}
                    isReview={isReview}
                />
            </ShowIf>
        </>
    );
};
